import { apiGet, apiPatch, apiPost, apiPut } from '@/shared/utils/requestBuilder';

import type {
  CriarSituacaoDto,
  EditarSituacaoDto,
  EscritorioOpcao,
  SituacaoArbitral,
} from '../types/situacaoArbitralTypes';

async function parseOuFalha<T>(response: Response, mensagemErro: string): Promise<T> {
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ error: mensagemErro }));
    throw new Error((errorData as { error?: string }).error || mensagemErro);
  }
  return (await response.json()) as T;
}

export const situacoesArbitralService = {
  listar: async (): Promise<SituacaoArbitral[]> => {
    const response = await apiGet('/admin/arbitral/situacoes/gerenciar');
    const result = await parseOuFalha<{ items: SituacaoArbitral[] }>(
      response,
      'Erro ao listar situações',
    );
    return result.items;
  },

  listarEscritorios: async (): Promise<EscritorioOpcao[]> => {
    const response = await apiGet('/escritorios');
    const result = await parseOuFalha<{ data: Array<{ id: string; nomeFantasia: string }> }>(
      response,
      'Erro ao listar câmaras',
    );
    return result.data.map((escritorio) => ({ id: escritorio.id, nome: escritorio.nomeFantasia }));
  },

  criar: async (data: CriarSituacaoDto): Promise<SituacaoArbitral> => {
    const response = await apiPost('/admin/arbitral/situacoes', data);
    return parseOuFalha<SituacaoArbitral>(response, 'Erro ao criar situação');
  },

  editar: async (id: string, data: EditarSituacaoDto): Promise<SituacaoArbitral> => {
    const response = await apiPut(`/admin/arbitral/situacoes/${id}`, data);
    return parseOuFalha<SituacaoArbitral>(response, 'Erro ao editar situação');
  },

  definirAtivacao: async (id: string, active: boolean): Promise<SituacaoArbitral> => {
    const response = await apiPatch(`/admin/arbitral/situacoes/${id}/ativacao`, { active });
    return parseOuFalha<SituacaoArbitral>(response, 'Erro ao alterar situação');
  },

  atualizarEscritorios: async (id: string, escritorioIds: string[]): Promise<SituacaoArbitral> => {
    const response = await apiPut(`/admin/arbitral/situacoes/${id}/escritorios`, { escritorioIds });
    return parseOuFalha<SituacaoArbitral>(response, 'Erro ao atualizar câmaras da situação');
  },
};
